import React, { forwardRef, useCallback } from 'react'

import {
  ContactFormLabelStyled,
  ContactFormInputStyled,
  ContactFormTextareaStyled,
  ContactFormSelectStyled,
  ContactFormFieldStyled,
  ContactFormPhoneInputStyled,
  ContactFormErrorStyled
} from './styles'
import { Fields } from '../../../enums/fields'
import { ContactFieldProps } from './types'
import PhoneInput, { parsePhoneNumber, PhoneInputProps } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { useField } from 'formik'
import { useState } from 'react'

const PhoneInputWrapper: PhoneInputProps['inputComponent'] = forwardRef((props, ref) => {
  return <ContactFormPhoneInputStyled ref={ref} {...(props as any)} />
})

const ContactField: React.FC<ContactFieldProps> = ({ isActive, isHalf, isSmall, isBig, isPhone, value, label, variant, items }) => {
  const [{ value: inputValue }, { touched, error }, { setValue }] = useField({ name: value })
  const [phoneFocused, setPhoneFocused] = useState<boolean>()

  const handlePhoneInputChange = useCallback(
    (value: string) => {
      const prevValue = inputValue ? parsePhoneNumber(inputValue) : undefined
      const nextValue = value ? parsePhoneNumber(value) : undefined

      if (!nextValue && prevValue && value) {
        setValue(`${value}${prevValue.nationalNumber}`)
      } else {
        setValue(value)
      }
    },
    [inputValue, setValue]
  )

  const renderLinkIconSwitch = (param?: string) => {
    switch (param) {
      case Fields.Text:
        return <ContactFormInputStyled type="text" name={value} id={value} />
      case Fields.Email:
        return <ContactFormInputStyled type="text" name={value} id={value} />
      case Fields.Prefix:
        return <ContactFormInputStyled type="tel" pattern="[0-9]{2}" name={value} id={value} maxLength="2" />
      case Fields.Phone:
        return (
          <PhoneInput
            id={value}
            name={value}
            international
            value={inputValue}
            onChange={handlePhoneInputChange}
            inputComponent={PhoneInputWrapper}
            onFocus={() => setPhoneFocused(true)}
            onBlur={() => setPhoneFocused(false)}
          />
        )
      case Fields.Message:
        return <ContactFormTextareaStyled as="textarea" name={value} id={value} />
      case Fields.Select:
        return (
          <ContactFormSelectStyled name={value} id={value} as="select">
            <option value=""></option>
            {items?.map((item) => (
              <option value={item.value} key={item.value}>
                {item.title}
              </option>
            ))}
          </ContactFormSelectStyled>
        )
      default:
        return
    }
  }

  return (
    <ContactFormFieldStyled {...{ isHalf, isSmall, isBig, isPhone }} isActive={isActive || phoneFocused}>
      {renderLinkIconSwitch(variant)}

      {label && <ContactFormLabelStyled htmlFor={value}>{label}</ContactFormLabelStyled>}

      {touched && error && <ContactFormErrorStyled>{error}</ContactFormErrorStyled>}
    </ContactFormFieldStyled>
  )
}

export default ContactField
